<template>
<aside>
  <nav>
    <ul>
      <li v-for="(menu, index) in menus" :key="index">
        <router-link v-bind:to="menu.path"
          @click.native="change(index)" v-bind:class="{'current': activeIndex === index}">
            {{ menu.pageName }}
        </router-link>
      </li>
    </ul>
  </nav>
</aside>
</template>

<script>
export default {
  data () {
    return {
      menus: [
        { pageName: 'ユーザー管理', path: '/corp_admin/user' },
        { pageName: 'お支払い情報', path: '/corp_admin/payment' },
        { pageName: '管理者情報', path: '/corp_admin/setting' }
      ],
      activeIndex: 0
    }
  },
  methods: {
    change: function (num) {
      this.activeIndex = num
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue